import { useEffect, useRef } from 'react';

const problems = [
  {
    icon: 'ri-drop-fill',
    title: '반복되는 누수 문제',
    desc: '기존 마감캡은 실리콘 처리를 별도로 해야 하며, 시간이 지나면 실리콘이 경화·수축되어 누수가 재발합니다.',
    stat: '건물 하자의 38%',
    statLabel: '지붕 누수가 차지',
  },
  {
    icon: 'ri-tools-fill',
    title: '복잡한 별도 방수 시공',
    desc: '시공 후 실란트·실리콘을 추가로 도포해야 하는 번거로운 2단계 작업으로 시공 시간과 비용이 증가합니다.',
    stat: '+30%',
    statLabel: '추가 인건비 발생',
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    title: '지속적인 유지보수 비용',
    desc: '3~5년 주기로 실리콘 재시공이 필요해 건물 관리자에게 반복적인 비용과 불편을 초래합니다.',
    stat: '평균 3~5년',
    statLabel: '마다 재시공 필요',
  },
  {
    icon: 'ri-error-warning-fill',
    title: '품질 편차와 시공 불량',
    desc: '현장 작업자의 숙련도에 따라 실리콘 도포 품질이 달라져 균일한 방수 성능을 보장하기 어렵습니다.',
    stat: '시공 불량률',
    statLabel: '작업자 숙련도 의존',
  },
];

const ProblemSection = () => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
          }
        });
      },
      { threshold: 0.15 }
    );
    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="problem" className="py-24 bg-[#F8F9FC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] text-sm font-semibold tracking-widest uppercase">Problem</span>
          <h2 className="mt-3 text-3xl lg:text-4xl font-bold text-[#1B2A4A] font-display">
            기존 마감캡의 한계
          </h2>
          <p className="mt-4 text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            수십 년간 이어온 구조적 문제, 이제는 해결할 시간입니다.
          </p>
          <div className="mt-4 w-12 h-1 bg-[#FF6B35] mx-auto rounded-full" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {problems.map((item, i) => (
            <div
              key={i}
              ref={(el) => { refs.current[i] = el; }}
              className="bg-white rounded-xl p-6 border border-gray-100 opacity-0 translate-y-6 transition-all duration-500 hover:border-[#FF6B35]/30 group"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-[#FF6B35]/10 mb-4 group-hover:bg-[#FF6B35] transition-colors duration-300">
                <i className={`${item.icon} text-xl text-[#FF6B35] group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="font-bold text-[#1B2A4A] text-base mb-2">{item.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{item.desc}</p>
              <div className="pt-4 border-t border-gray-100">
                <p className="text-[#FF6B35] font-bold text-lg">{item.stat}</p>
                <p className="text-gray-400 text-xs mt-0.5">{item.statLabel}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
